import { MonthlyIncomeFieldData } from './monthly-income';
import { MobilePhoneFieldData } from './mobile-phone';
import { LastNameOnCardFieldData } from './last-name-on-card';
import { LastNameFieldData } from './last-name';
import { LastFourSSNFieldData } from './last-four-ssn';
import { FirstNameOnCardFieldData } from './first-name-on-card';
import { FirstNameFieldData } from './first-name';
import { CheckingAccountNumberFieldData } from './checking-account-number';
import { Injectable } from '@angular/core';
import { CardExpirationDateFieldData } from './card-expiration-date';
import { DateOfBirthFieldData } from './date-of-birth';
import { DriverLicenseFieldData } from './driver-license';
import { DriverLicenseStateFieldData } from './driver-license-state';
import { EmailFieldData } from './email';
import { RoutingNumberFieldData } from './routing-number';
import { SSNorITINFieldData } from './ssn-itin';

const FieldDefinitions = {
  cardExpirationDate: CardExpirationDateFieldData,
  checkingAccountNumber: CheckingAccountNumberFieldData,
  dateOfBirth: DateOfBirthFieldData,
  driverLicense: DriverLicenseFieldData,
  driverLicenseState: DriverLicenseStateFieldData,
  email: EmailFieldData,
  firstName: FirstNameFieldData,
  firstNameOnCard: FirstNameOnCardFieldData,
  lastFourSSN: LastFourSSNFieldData,
  lastName: LastNameFieldData,
  lastNameOnCard: LastNameOnCardFieldData,
  mobilePhone: MobilePhoneFieldData,
  monthlyIncome: MonthlyIncomeFieldData,
  routingNumber: RoutingNumberFieldData,
  ssnItin: SSNorITINFieldData,
};
const CustomDefinitions = {};
@Injectable({
  providedIn: 'root',
})
export class FieldDataService {
  constructor() {}

  registerFieldData(key: string, data: any) {
    CustomDefinitions[key] = data;
  }
  getFieldData(key: string) {
    let field = FieldDefinitions[key];
    if (!field) {
      field = CustomDefinitions[key];
    }
    return field;
  }

  getFieldDefinitionsArray() {
    return Object.keys(FieldDefinitions).map(key => {
      return {
        key: key,
        data: FieldDefinitions[key],
      };
    });
  }
}
